<div class="info-stocks-statistics">
	<div
		#fundamentalData
		class="fundamental-data-widget"
	></div>
	@if (isLoadingFundamentalData()) {
		<ng-container *ngTemplateOutlet="skeletonFundamentalData" />
	}
</div>

<ng-template #skeletonFundamentalData>
	<div class="skeleton-fundamental-data">
		<div
			class="title"
			[tuiSkeleton]="true"
		></div>
		<div class="columns">
			@for (_ of [].constructor(2); track $index) {
				<div class="column">
					@for (_ of [].constructor(15); track $index) {
						<div
							class="item"
							[tuiSkeleton]="true"
						></div>
					}
				</div>
			}
		</div>
	</div>
</ng-template>
